// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b31e2ac","337":"7345bcbc","453":"9e1da91a","455":"08860f9e"}[chunkId] + ".chunk.js";
};